import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Assets by Lane of Support',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  slices: {
                    '[]': [
                      {
                        '{}': {
                          name: 'OOTB Enablement',
                          value: {
                            '#': {
                              '@': 'ootbEnablement',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Proprietary Agents & Workflows',
                          value: {
                            '#': {
                              '@': 'proprietaryAgentsWorkflows',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Platform & Co-Dev',
                          value: {
                            '#': {
                              '@': 'platformCoDev',
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'donut',
        },
      },
    },
  },
  subqueries: {
    platformCoDev: {
      filter: {
        '=': [
          {
            '@.': '!lane_of_support',
          },
          'Platform & Co-Dev',
        ],
      },
      target: 'ent:!innovation_assets:!innovation_asset',
      selection: {
        '@.': '!id',
      },
    },
    ootbEnablement: {
      filter: {
        '=': [
          {
            '@.': '!lane_of_support',
          },
          'OOTB Enablement',
        ],
      },
      target: 'ent:!innovation_assets:!innovation_asset',
      selection: {
        '@.': '!id',
      },
    },
    proprietaryAgentsWorkflows: {
      filter: {
        '=': [
          {
            '@.': '!lane_of_support',
          },
          'Proprietary Agents & Workflows',
        ],
      },
      target: 'ent:!innovation_assets:!innovation_asset',
      selection: {
        '@.': '!id',
      },
    },
  },
}
